import type {FilterObject} from 'nutshell-core/types';

import type {
    InstallmentsReportApiResponse,
    InstallmentsReportFacet,
} from './installments-report-api';

export const ActionTypes = {
    INSTALLMENTS_REPORT_FETCH_REQUEST: 'INSTALLMENTS_REPORT_FETCH_REQUEST',
    INSTALLMENTS_REPORT_FETCH_SUCCESS: 'INSTALLMENTS_REPORT_FETCH_SUCCESS',
    INSTALLMENTS_REPORT_FETCH_FAILURE: 'INSTALLMENTS_REPORT_FETCH_FAILURE',
} as const;

export type InstallmentsReportRequestPayload = {
    activeFilters: FilterObject[];
    gap: string;
    facet: InstallmentsReportFacet;
    includeOpenLeads: boolean;
};

export type InstallmentsReportRequestAction = {
    type: typeof ActionTypes.INSTALLMENTS_REPORT_FETCH_REQUEST;
    payload: InstallmentsReportRequestPayload;
};

export type InstallmentsReportSuccessAction = {
    type: typeof ActionTypes.INSTALLMENTS_REPORT_FETCH_SUCCESS;
    payload: InstallmentsReportApiResponse;
};

export type InstallmentsReportFailureAction = {
    type: typeof ActionTypes.INSTALLMENTS_REPORT_FETCH_FAILURE;
    error: true;
    payload: unknown;
};

export type InstallmentsReportAction =
    | InstallmentsReportRequestAction
    | InstallmentsReportSuccessAction
    | InstallmentsReportFailureAction;

export const requestInstallmentsReport = (
    payload: InstallmentsReportRequestPayload
): InstallmentsReportRequestAction => ({
    type: ActionTypes.INSTALLMENTS_REPORT_FETCH_REQUEST,
    payload,
});

export const resolveInstallmentsReport = (
    payload: InstallmentsReportApiResponse
): InstallmentsReportSuccessAction => ({
    type: ActionTypes.INSTALLMENTS_REPORT_FETCH_SUCCESS,
    payload,
});

export const failInstallmentsReport = (err: unknown): InstallmentsReportFailureAction => ({
    type: ActionTypes.INSTALLMENTS_REPORT_FETCH_FAILURE,
    payload: err,
    error: true,
});
